import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';

const TITLE = "Décompte jusqu'à la Nuit du mi-Sha'ban 2027 - Jours restants";
const DESCRIPTION = "Combien de jours restants jusqu'à la Nuit du mi-Sha'ban 2027 ? Le décompte jusqu'à la Nuit du mi-Sha'ban 1448 AH vous fournit des informations précises sur la date de cette nuit bénie, combien de jours restent jusqu'à la Nuit du 15 Sha'ban, et le nombre de jours restants.";
const KEYWORDS = "Nuit du mi-Sha'ban 2027, Sha'ban 2027, décompte Sha'ban, date Nuit du mi-Sha'ban 2027, combien de jours jusqu'à Sha'ban";
const OG_URL = "https://do-calculate.com/articles-fr/shaban";

function Shaban() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const initialDate = new Date("2027-01-22T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(initialDate));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);

    const shabanDates = [
        { name: "Nuit du mi-Sha'ban 2027", date: new Date("2027-01-22T00:00:00") },
        { name: "Nuit du mi-Sha'ban 2028", date: new Date("2028-01-11T00:00:00") },
    ];

    const dayName = initialDate.toLocaleDateString('fr-FR', { weekday: 'long' });

    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">
                Décompte jusqu'à la Nuit du mi-Sha'ban 2027
            </h1>
            <div>
                <BlinkingText text={`Décompte jusqu'à la Nuit du mi-Sha'ban : la Nuit du mi-Sha'ban 2027 devrait avoir lieu le ${dayName} 22/01/2027 (grégorien) correspondant au 14 Sha'ban 1448 (hégirien).`} />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className="p-3 mb-2 bg-success text-white" style={{ fontSize: '28px', textAlign: 'center' }}>
                            Prochaines dates de la Nuit du mi-Sha'ban
                        </h2>
                        <table style={{ fontSize: '20px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Événement</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Date</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jours restants</th>
                                </tr>
                            </thead>
                            <tbody>
                                {shabanDates.map((item, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{item.name}</td>
                                        <td style={{ padding: '12px' }}>{item.date.toLocaleDateString('fr-FR')}</td>
                                        <td style={{ padding: '12px' }}>
                                            {Math.max(0, calculateTimeLeft(item.date).days ?? 0)} jours
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-4 col-md-4">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Décompte jusqu'à la Nuit du mi-Sha'ban 2027</h3>
                    <p>
                        Dans cet article, nous vous proposons un décompte détaillé jusqu'à la Nuit du mi-Sha'ban, afin que vous puissiez être informé à tout moment du nombre de jours restants jusqu'à l'arrivée de cette nuit bénie. Beaucoup d'entre nous se demandent combien de jours restent jusqu'à la Nuit du mi-Sha'ban. C'est pourquoi, dans cet article, nous vous présentons le décompte jusqu'à la Nuit du mi-Sha'ban, vous permettant de savoir combien de temps reste jusqu'à cette nuit sacrée.
                    </p>
                    <p>
                        La Nuit du mi-Sha'ban 2027 devrait avoir lieu le {dayName} 22/01/2027 (grégorien) correspondant au 14 Sha'ban 1448 (hégirien). Vous pouvez voir le décompte dans cet article.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className="p-3 mb-2 bg-success text-white">
                        Calculer les jours restants jusqu'à la Nuit du mi-Sha'ban
                    </h3>
                    <p>
                        Grâce au programme de décompte de la Nuit du mi-Sha'ban, vous pouvez savoir combien de jours restent jusqu'à cette nuit dans les calendriers grégorien et hégirien. Vous pouvez également découvrir combien de jours restent jusqu'à la Nuit du mi-Sha'ban et quand elle aura lieu.
                    </p>
                    <h3 className="p-3 mb-2 bg-success text-white">La Nuit du mi-Sha'ban</h3>
                    <p>
                        La Nuit du mi-Sha'ban est la nuit du quinzième jour du mois de Sha'ban dans le calendrier hégirien. Elle commence au coucher du soleil du 14 Sha'ban et se termine à l'aube du 15 Sha'ban. Cette nuit revêt une importance particulière en Islam, car de nombreux hadiths du Prophète (paix et bénédictions sur lui) mentionnent ses vertus. Les musulmans la commémorent en accomplissant des prières supplémentaires, en récitant le Coran et en invoquant Allah.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="Décompte jusqu'à la Nuit du mi-Sha'ban"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default Shaban;
